import { FilterDropdown } from "@repo/ui";

import type { DropDownProps } from ".";

interface Props extends DropDownProps<"companyDivisionIds"> {}

export function DivisionsDropdown(props: Props) {
	return (
		<FilterDropdown
			{...props}
			id="companyDivisionIds"
			values={props.options?.data ?? []}
			objectName="Divisions"
			label={props.label ?? "Division"}
			fullLength
			isMulti
		/>
	);
}
